import {
    DropDown,
    Popover,
    requiredRule,
    useErrorState,
    ValidatedDropDownList,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { BOValidatedDatePicker } from 'base-components/BOValidatedDatePicker/BOValidatedDatePicker';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { getSelectList } from 'axios/dictionaryApi';
import { addOrderAgreementProlongation } from 'axios/orderApi';
import { getDbDateTime } from 'axios/settingsApi';
import { datetimeWithSecondsFormat } from 'constans/dateFormat';
import useApi from 'hooks/useApi';
import { AgreementProlongationAdd } from 'models/api/order';
import { Key, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

const ProlongationAgreementAddPopover = ({
    refetchQueryKey,
    loanId,
}: {
    refetchQueryKey: string[];
    loanId: Key;
}) => {
    const api = useApi();
    const { t, i18n } = useTranslation();
    const { handleRequestError } = useErrorState();
    const [dbDateTime, setDbDateTime] = useState<string>();

    const [loanProlongationTypes, setLoanProlongationTypes] = useState<DropDown[] | null>(null);

    const { isFetching } = useQuery(
        'loanProlongationTypes',
        () => getSelectList(api, ['LoanProlongationTypes'], i18n.language),
        {
            onSuccess: (res) => {
                res['LoanProlongationTypes'] &&
                    setLoanProlongationTypes(res['LoanProlongationTypes']);
            },
            enabled: !loanProlongationTypes,
            onError: (err) => {
                handleRequestError(err);
            },
        }
    );

    const { isFetching: dateTimeFetching } = useQuery('dbDateTime', () => getDbDateTime(api), {
        onSuccess: (data) => setDbDateTime(data),
        enabled: !dbDateTime,
    });

    const mutationFunction = (data: AgreementProlongationAdd) => {
        return addOrderAgreementProlongation(api, data);
    };

    const keyToNumber = (val: Key | null | undefined) => {
        switch (typeof val) {
            case 'number':
                return val;
            case 'string':
                return parseInt(val);
            default:
                return 0;
        }
    };

    return (
        <Popover<AgreementProlongationAdd>
            buttonIcon={faPlus}
            buttonLabel={''}
            canSave={true}
            defaultValues={{
                dsc: '',
                loanId: keyToNumber(loanId),
                term: keyToNumber(loanProlongationTypes && loanProlongationTypes[0].id),
                agreementDate: dbDateTime,
            }}
            header={<Trans i18nKey="BackOfficeAddConsent" />}
            label="close"
            mutationFunction={mutationFunction}
            popoverContainer="body"
            refetchQueryKeys={refetchQueryKey}
            textStyle="success"
        >
            <ValidatedDropDownList<AgreementProlongationAdd>
                name="term"
                label={t('BackOfficeTerm')}
                items={loanProlongationTypes ?? []}
                isLoading={isFetching}
                isClearable={false}
                menuPortalTarget={null}
                rules={{
                    required: requiredRule,
                }}
            />
            <BOValidatedDatePicker
                name="agreementDate"
                dateFormat={datetimeWithSecondsFormat}
                inputProps={{ label: t('BackOfficeConsentDate'), loading: dateTimeFetching }}
                rules={{
                    required: requiredRule,
                }}
            />
            <ValidatedInput<AgreementProlongationAdd>
                name="dsc"
                type="textarea"
                label={t('BackOfficeComment')}
                rules={{
                    required: requiredRule,
                }}
            />
        </Popover>
    );
};

export default ProlongationAgreementAddPopover;
